var _defs, _g, _path, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 576",
    height: 768,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "d108faa5a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 344 57.601562 L 768 57.601562 L 768 496 L 344 496 Z M 344 57.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "002006e4e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 547.863281 363.320312 L 636.914062 363.320312 L 636.914062 399.429688 L 547.863281 399.429688 Z M 547.863281 363.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7aba8602c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 592.386719 363.320312 C 567.796875 363.320312 547.863281 371.40625 547.863281 381.375 C 547.863281 391.347656 567.796875 399.429688 592.386719 399.429688 C 616.980469 399.429688 636.914062 391.347656 636.914062 381.375 C 636.914062 371.40625 616.980469 363.320312 592.386719 363.320312 Z M 592.386719 363.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "099e4284e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 575 373 L 644 373 L 644 442 L 575 442 Z M 575 373 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea3bbde084"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 659.132812 432.261719 L 591.324219 450.28125 L 575.714844 391.5625 L 643.523438 373.539062 Z M 659.132812 432.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d775ba2db5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 643.523438 373.539062 L 625.230469 441.273438 L 575.714844 391.5625 Z M 643.523438 373.539062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c4545cdae3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 584.925781 344.714844 L 667.75 344.714844 L 667.75 440.824219 L 584.925781 440.824219 Z M 584.925781 344.714844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5d4f516ed2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 573.261719 267.660156 L 679.21875 267.660156 L 679.21875 373.617188 L 573.261719 373.617188 Z M 573.261719 267.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b6226a46b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 626.242188 267.660156 C 596.898438 267.660156 573.261719 291.296875 573.261719 320.636719 C 573.261719 349.980469 596.898438 373.617188 626.242188 373.617188 C 655.3125 373.617188 679.21875 349.980469 679.21875 320.636719 C 679.21875 291.296875 655.3125 267.660156 626.242188 267.660156 Z M 626.242188 365.464844 C 601.519531 365.464844 581.414062 345.359375 581.414062 320.636719 C 581.414062 295.914062 601.519531 275.808594 626.242188 275.808594 C 650.964844 275.808594 671.070312 295.914062 671.070312 320.636719 C 671.070312 345.359375 650.964844 365.464844 626.242188 365.464844 Z M 626.242188 365.464844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "76731655df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 581.125 275.523438 L 671.355469 275.523438 L 671.355469 365.753906 L 581.125 365.753906 Z M 581.125 275.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d279bef2d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 626.242188 275.808594 C 601.519531 275.808594 581.414062 295.914062 581.414062 320.636719 C 581.414062 345.359375 601.519531 365.464844 626.242188 365.464844 C 650.964844 365.464844 671.070312 345.359375 671.070312 320.636719 C 671.070312 295.914062 650.964844 275.808594 626.242188 275.808594 Z M 626.242188 275.808594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "384d5f991a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 416.347656 333.105469 L 507.203125 333.105469 L 507.203125 370.902344 L 416.347656 370.902344 Z M 416.347656 333.105469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b67aafce97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 461.773438 333.105469 C 436.683594 333.105469 416.347656 341.566406 416.347656 352.003906 C 416.347656 362.441406 436.683594 370.902344 461.773438 370.902344 C 486.863281 370.902344 507.203125 362.441406 507.203125 352.003906 C 507.203125 341.566406 486.863281 333.105469 461.773438 333.105469 Z M 461.773438 333.105469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d9429fc7e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 454 352 L 506 352 L 506 405 L 454 405 Z M 454 352 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec0d345845"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 517.761719 397.292969 L 466.078125 411.03125 L 454.183594 366.277344 L 505.863281 352.539062 Z M 517.761719 397.292969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cfcfe6fa7d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 505.863281 352.539062 L 491.917969 404.164062 L 454.183594 366.277344 Z M 505.863281 352.539062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "abc0603daa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 458.664062 322.601562 L 530.042969 322.601562 L 530.042969 405.429688 L 458.664062 405.429688 Z M 458.664062 322.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8ac613bef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 448.613281 256.199219 L 539.925781 256.199219 L 539.925781 347.511719 L 448.613281 347.511719 Z M 448.613281 256.199219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3860155b0f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 494.269531 256.199219 C 468.984375 256.199219 448.613281 276.570312 448.613281 301.855469 C 448.613281 327.140625 468.984375 347.511719 494.269531 347.511719 C 519.324219 347.511719 539.925781 327.140625 539.925781 301.855469 C 539.925781 276.570312 519.324219 256.199219 494.269531 256.199219 Z M 494.269531 340.488281 C 472.964844 340.488281 455.640625 323.160156 455.640625 301.855469 C 455.640625 280.546875 472.964844 263.222656 494.269531 263.222656 C 515.578125 263.222656 532.902344 280.546875 532.902344 301.855469 C 532.902344 323.160156 515.578125 340.488281 494.269531 340.488281 Z M 494.269531 340.488281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ceaa151d08"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 455.390625 263 L 533 263 L 533 340.734375 L 455.390625 340.734375 Z M 455.390625 263 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "34b28d658e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 494.269531 263.222656 C 472.964844 263.222656 455.640625 280.546875 455.640625 301.855469 C 455.640625 323.160156 472.964844 340.488281 494.269531 340.488281 C 515.578125 340.488281 532.902344 323.160156 532.902344 301.855469 C 532.902344 280.546875 515.578125 263.222656 494.269531 263.222656 Z M 494.269531 263.222656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4e32d96176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 343.6875 186.796875 L 425.164062 186.796875 L 425.164062 218.011719 L 343.6875 218.011719 Z M 343.6875 186.796875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce5b672439"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 384.425781 186.796875 C 361.925781 186.796875 343.6875 193.785156 343.6875 202.40625 C 343.6875 211.027344 361.925781 218.011719 384.425781 218.011719 C 406.925781 218.011719 425.164062 211.027344 425.164062 202.40625 C 425.164062 193.785156 406.925781 186.796875 384.425781 186.796875 Z M 384.425781 186.796875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "87cf00b7de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 375 199 L 422 199 L 422 247 L 375 247 Z M 375 199 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6dbb1ba721"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 432.214844 239.882812 L 385.867188 252.203125 L 375.199219 212.066406 L 421.546875 199.75 Z M 432.214844 239.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "119dae3853"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 421.546875 199.75 L 409.042969 246.042969 L 375.199219 212.066406 Z M 421.546875 199.75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "297133388e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 383.210938 187.011719 L 435.867188 187.011719 L 435.867188 248.113281 L 383.210938 248.113281 Z M 383.210938 187.011719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "76f2215b5d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 375.792969 138.019531 L 443.160156 138.019531 L 443.160156 205.386719 L 375.792969 205.386719 Z M 375.792969 138.019531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b3f30eecca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 409.476562 138.019531 C 390.820312 138.019531 375.792969 153.046875 375.792969 171.703125 C 375.792969 190.359375 390.820312 205.386719 409.476562 205.386719 C 427.957031 205.386719 443.160156 190.359375 443.160156 171.703125 C 443.160156 153.046875 427.957031 138.019531 409.476562 138.019531 Z M 409.476562 200.203125 C 393.757812 200.203125 380.976562 187.421875 380.976562 171.703125 C 380.976562 155.984375 393.757812 143.203125 409.476562 143.203125 C 425.195312 143.203125 437.976562 155.984375 437.976562 171.703125 C 437.976562 187.421875 425.195312 200.203125 409.476562 200.203125 Z M 409.476562 200.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bcb46d0015"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 380.792969 143.019531 L 438 143.019531 L 438 200.386719 L 380.792969 200.386719 Z M 380.792969 143.019531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c0e5956c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 409.476562 143.203125 C 393.757812 143.203125 380.976562 155.984375 380.976562 171.703125 C 380.976562 187.421875 393.757812 200.203125 409.476562 200.203125 C 425.195312 200.203125 437.976562 187.421875 437.976562 171.703125 C 437.976562 155.984375 425.195312 143.203125 409.476562 143.203125 Z M 409.476562 143.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2eb1f07d35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 454.261719 141.558594 L 525.964844 141.558594 L 525.964844 170.546875 L 454.261719 170.546875 Z M 454.261719 141.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b8eeedaca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 490.113281 141.558594 C 470.3125 141.558594 454.261719 148.046875 454.261719 156.050781 C 454.261719 164.058594 470.3125 170.546875 490.113281 170.546875 C 509.914062 170.546875 525.964844 164.058594 525.964844 156.050781 C 525.964844 148.046875 509.914062 141.558594 490.113281 141.558594 Z M 490.113281 141.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58410b110e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 482 153 L 524 153 L 524 195 L 482 195 Z M 482 153 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f63ef70bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 532.613281 188.910156 L 491.828125 199.75 L 482.441406 164.433594 L 523.226562 153.589844 Z M 532.613281 188.910156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d0c26f95cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 523.226562 153.589844 L 512.222656 194.332031 L 482.441406 164.433594 Z M 523.226562 153.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8ad561d53d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 489.539062 142.859375 L 533.789062 142.859375 L 533.789062 194.609375 L 489.539062 194.609375 Z M 489.539062 142.859375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf872afce2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 483.265625 102.015625 L 539.925781 102.015625 L 539.925781 158.675781 L 483.265625 158.675781 Z M 483.265625 102.015625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2185ee2b94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 511.597656 102.015625 C 495.90625 102.015625 483.265625 114.65625 483.265625 130.347656 C 483.265625 146.035156 495.90625 158.675781 511.597656 158.675781 C 527.140625 158.675781 539.925781 146.035156 539.925781 130.347656 C 539.925781 114.65625 527.140625 102.015625 511.597656 102.015625 Z M 511.597656 154.320312 C 498.375 154.320312 487.625 143.566406 487.625 130.347656 C 487.625 117.125 498.375 106.375 511.597656 106.375 C 524.816406 106.375 535.570312 117.125 535.570312 130.347656 C 535.570312 143.566406 524.816406 154.320312 511.597656 154.320312 Z M 511.597656 154.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1b355d470"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 487.46875 106.21875 L 535.722656 106.21875 L 535.722656 154.472656 L 487.46875 154.472656 Z M 487.46875 106.21875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "78a08935be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 511.597656 106.375 C 498.375 106.375 487.625 117.125 487.625 130.347656 C 487.625 143.566406 498.375 154.320312 511.597656 154.320312 C 524.816406 154.320312 535.570312 143.566406 535.570312 130.347656 C 535.570312 117.125 524.816406 106.375 511.597656 106.375 Z M 511.597656 106.375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d108faa5a7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M 622.628906 57.601562 C 658.816406 83.441406 678.992188 125.457031 640.804688 166.136719 C 615.625 192.816406 573.265625 211.488281 539.914062 225.660156 C 488.386719 247.335938 356.8125 291.515625 388.164062 372.546875 C 397.003906 395.21875 418.683594 410.390625 439.359375 421.230469 C 502.050781 453.742188 605.925781 454.308594 684.898438 449.167969 L 690.96875 448.738281 L 702.03125 432.703125 L 768.183594 459.703125 L 658.65625 495.585938 L 667.199219 483.203125 L 645.988281 484.246094 C 574.167969 487.28125 495.996094 486.023438 431.355469 457.574219 C 416.679688 451.074219 402.671875 443.238281 389.5 433.902344 C 344.472656 401.554688 328.464844 353.207031 363.484375 306.355469 C 398.003906 260.003906 507.5625 226.992188 562.09375 202.484375 C 581.773438 193.648438 602.285156 183.3125 619.457031 170.308594 C 668.15625 133.792969 658.648438 90.777344 622.628906 57.601562 Z M 622.628906 57.601562 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 524.558594 458.0625 L 541.703125 460.300781 C 595.96875 466.253906 650.707031 464.769531 686.21875 462.582031 C 687.886719 462.582031 689.21875 463.746094 689.386719 465.414062 C 689.554688 467.078125 688.222656 468.578125 686.558594 468.742188 C 650.027344 470.785156 592.695312 472.058594 536.28125 465.148438 L 523.035156 463.230469 Z M 406.601562 418.335938 L 407.589844 419.089844 C 430.964844 435.527344 462.101562 446.308594 495.773438 453.21875 L 508.59375 455.503906 L 507.097656 460.664062 L 488.660156 457.050781 C 457.734375 450.085938 429.136719 439.753906 406.917969 424.675781 L 403.425781 422.117188 Z M 366.140625 328.308594 L 370.3125 330.132812 L 367.816406 338.054688 C 364.652344 352.527344 366.808594 368.535156 376.726562 386.144531 C 381.101562 393.90625 386.660156 400.925781 393.214844 407.273438 L 393.519531 407.542969 L 390.375 411.292969 L 384.824219 405.632812 C 378.496094 398.570312 373.285156 390.765625 369.390625 382.148438 C 360.890625 363.257812 360.199219 346.289062 365.101562 330.992188 Z M 428.949219 265.769531 L 430.949219 269.167969 L 420.175781 275.816406 C 405.882812 285.125 392.636719 295.847656 382.871094 308.054688 L 376.652344 316.898438 L 372.546875 315.101562 L 376.386719 309.277344 C 388 293.316406 405.738281 279.46875 426.101562 267.347656 Z M 496.480469 233.808594 L 497.980469 237.453125 L 494.566406 238.800781 C 487.125 241.773438 480.164062 244.636719 473.890625 247.425781 C 467.347656 250.363281 460.304688 253.628906 453.0625 257.238281 L 437.695312 265.523438 L 435.671875 262.046875 L 444.113281 257.371094 C 456.441406 250.988281 469.300781 245.136719 482.039062 239.734375 Z M 555.878906 210.523438 L 557.179688 213.359375 L 543.230469 219.449219 C 530.492188 224.730469 517.859375 229.632812 506.058594 234.261719 L 503.722656 235.183594 L 502.257812 231.464844 L 519.226562 224.828125 C 531.0625 220.265625 542.125 216.082031 551.757812 212.210938 Z M 608.34375 184.179688 L 609.5 186.117188 L 604.472656 189.414062 C 593.390625 196.246094 581.199219 202.523438 568.640625 208.355469 L 562.21875 211.160156 L 560.9375 208.402344 L 565.054688 206.625 C 573.972656 202.671875 583.898438 198.070312 593.820312 192.699219 Z M 639.800781 157.414062 L 641.394531 158.675781 L 641.238281 158.898438 C 634.378906 167.386719 625.445312 175.183594 615.171875 182.394531 L 613.542969 183.464844 L 612.3125 181.394531 L 622.554688 174.132812 C 627.003906 170.609375 631.195312 166.863281 635.007812 162.871094 Z M 653.683594 130.859375 L 655.550781 131.15625 L 655.296875 132.28125 C 653.675781 138.066406 651.074219 144.023438 647.390625 150.175781 L 643.933594 155.082031 L 642.457031 153.898438 L 645.164062 150.164062 C 648.085938 145.679688 650.496094 140.933594 652.269531 135.917969 Z M 656.445312 107.949219 L 656.851562 110.019531 C 657.628906 115.378906 657.585938 120.882812 656.597656 126.550781 L 656.398438 127.414062 L 654.570312 127.179688 L 655.558594 120.03125 C 655.765625 117.160156 655.742188 114.40625 655.519531 111.753906 L 654.945312 108.226562 Z M 650.9375 92.152344 L 652.167969 94.371094 C 653.707031 97.757812 654.929688 101.203125 655.800781 104.710938 L 655.917969 105.28125 L 654.511719 105.539062 L 654.28125 104.09375 C 653.675781 101.632812 652.910156 99.253906 651.992188 96.945312 L 649.945312 92.589844 Z M 643 79.480469 L 646.640625 84.367188 L 649.960938 90.378906 L 649.085938 90.765625 L 648.828125 90.203125 C 647.640625 88.011719 646.339844 85.871094 644.949219 83.765625 L 642.273438 79.988281 Z M 637.957031 73.082031 L 639.417969 74.671875 L 642.289062 78.523438 L 641.578125 79.003906 L 640.535156 77.527344 L 637.386719 73.589844 Z M 630.722656 65.242188 L 637.355469 72.433594 L 636.796875 72.847656 Z M 630.722656 65.242188 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M 667.222656 483.355469 L 690.878906 448.957031 L 704.699219 458.085938 L 697.441406 478.863281 Z M 667.222656 483.355469 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#002006e4e9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7aba8602c6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 547.863281 363.320312 L 636.914062 363.320312 L 636.914062 399.429688 L 547.863281 399.429688 Z M 547.863281 363.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#099e4284e9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea3bbde084)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d775ba2db5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 659.132812 432.261719 L 591.324219 450.28125 L 575.714844 391.5625 L 643.523438 373.539062 Z M 659.132812 432.261719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4545cdae3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#08bdf2",
    d: "M 667.730469 344.714844 L 626.339844 440.824219 L 584.945312 344.714844 Z M 667.730469 344.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5d4f516ed2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b6226a46b4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#08bdf2",
    d: "M 573.261719 267.660156 L 679.21875 267.660156 L 679.21875 373.617188 L 573.261719 373.617188 Z M 573.261719 267.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76731655df)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d279bef2d5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    d: "M 573.261719 267.660156 L 679.21875 267.660156 L 679.21875 373.617188 L 573.261719 373.617188 Z M 573.261719 267.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#384d5f991a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b67aafce97)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 416.347656 333.105469 L 507.203125 333.105469 L 507.203125 370.902344 L 416.347656 370.902344 Z M 416.347656 333.105469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d9429fc7e4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec0d345845)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cfcfe6fa7d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 517.761719 397.292969 L 466.078125 411.03125 L 454.183594 366.277344 L 505.863281 352.539062 Z M 517.761719 397.292969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#abc0603daa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39dbb2",
    d: "M 530.027344 322.601562 L 494.355469 405.429688 L 458.683594 322.601562 Z M 530.027344 322.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a8ac613bef)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3860155b0f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39dbb2",
    d: "M 448.613281 256.199219 L 539.925781 256.199219 L 539.925781 347.511719 L 448.613281 347.511719 Z M 448.613281 256.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ceaa151d08)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#34b28d658e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    d: "M 448.613281 256.199219 L 539.925781 256.199219 L 539.925781 347.511719 L 448.613281 347.511719 Z M 448.613281 256.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4e32d96176)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce5b672439)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 343.6875 186.796875 L 425.164062 186.796875 L 425.164062 218.011719 L 343.6875 218.011719 Z M 343.6875 186.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#87cf00b7de)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6dbb1ba721)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#119dae3853)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 432.214844 239.882812 L 385.867188 252.203125 L 375.199219 212.066406 L 421.546875 199.75 Z M 432.214844 239.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#297133388e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 435.855469 187.011719 L 409.539062 248.113281 L 383.222656 187.011719 Z M 435.855469 187.011719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76f2215b5d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b3f30eecca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 375.792969 138.019531 L 443.160156 138.019531 L 443.160156 205.386719 L 375.792969 205.386719 Z M 375.792969 138.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bcb46d0015)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c0e5956c4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    d: "M 375.792969 138.019531 L 443.160156 138.019531 L 443.160156 205.386719 L 375.792969 205.386719 Z M 375.792969 138.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2eb1f07d35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4b8eeedaca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 454.261719 141.558594 L 525.964844 141.558594 L 525.964844 170.546875 L 454.261719 170.546875 Z M 454.261719 141.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58410b110e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f63ef70bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d0c26f95cb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 532.613281 188.910156 L 491.828125 199.75 L 482.441406 164.433594 L 523.226562 153.589844 Z M 532.613281 188.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8ad561d53d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5757",
    d: "M 533.777344 142.859375 L 511.664062 194.609375 L 489.550781 142.859375 Z M 533.777344 142.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf872afce2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2185ee2b94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5757",
    d: "M 483.265625 102.015625 L 539.925781 102.015625 L 539.925781 158.675781 L 483.265625 158.675781 Z M 483.265625 102.015625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1b355d470)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#78a08935be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    d: "M 483.265625 102.015625 L 539.925781 102.015625 L 539.925781 158.675781 L 483.265625 158.675781 Z M 483.265625 102.015625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(497.659579, 138.722802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.667969 0.34375 C 13.308594 0.34375 16.097656 -3.035156 16.097656 -8.640625 C 16.097656 -14.246094 13.308594 -17.628906 8.667969 -17.628906 C 4.023438 -17.628906 1.234375 -14.246094 1.234375 -8.640625 C 1.234375 -3.035156 4.023438 0.34375 8.667969 0.34375 Z M 5.035156 -8.640625 C 5.035156 -12.074219 6.34375 -14.121094 8.667969 -14.121094 C 10.960938 -14.121094 12.269531 -12.074219 12.269531 -8.640625 C 12.269531 -5.210938 10.960938 -3.160156 8.667969 -3.160156 C 6.34375 -3.160156 5.035156 -5.210938 5.035156 -8.640625 Z M 5.035156 -8.640625 "
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(514.967303, 138.722802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.617188 0 L 8.46875 0 L 8.46875 -17.28125 L 5.53125 -17.28125 L 5.234375 -16.320312 C 4.839844 -15.035156 4.097656 -14.566406 2.46875 -14.566406 L 0.714844 -14.566406 L 0.714844 -11.136719 L 4.617188 -11.136719 Z M 4.617188 0 "
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(393.128966, 178.700887)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.15625 0.363281 C 14.058594 0.363281 17.007812 -3.207031 17.007812 -9.128906 C 17.007812 -15.050781 14.058594 -18.625 9.15625 -18.625 C 4.25 -18.625 1.304688 -15.050781 1.304688 -9.128906 C 1.304688 -3.207031 4.25 0.363281 9.15625 0.363281 Z M 5.320312 -9.128906 C 5.320312 -12.753906 6.703125 -14.921875 9.15625 -14.921875 C 11.582031 -14.921875 12.964844 -12.753906 12.964844 -9.128906 C 12.964844 -5.503906 11.582031 -3.339844 9.15625 -3.339844 C 6.703125 -3.339844 5.320312 -5.503906 5.320312 -9.128906 Z M 5.320312 -9.128906 "
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.414351, 178.700887)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.332031 0 L 15.023438 0 L 15.023438 -3.625 L 7.878906 -3.625 L 11.320312 -6.625 C 13.796875 -8.6875 14.6875 -10.722656 14.6875 -12.753906 C 14.6875 -16.304688 12 -18.625 8.113281 -18.625 C 4.09375 -18.625 1.589844 -16.199219 1.488281 -12.128906 L 5.269531 -12.128906 C 5.347656 -14.007812 6.390625 -15.078125 8.035156 -15.078125 C 9.625 -15.078125 10.695312 -14.058594 10.695312 -12.574219 C 10.695312 -11.449219 10.09375 -10.484375 8.867188 -9.390625 L 1.332031 -2.921875 Z M 1.332031 0 "
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(471.852272, 315.362713)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 11.894531 0.472656 C 18.265625 0.472656 22.09375 -4.167969 22.09375 -11.859375 C 22.09375 -19.554688 18.265625 -24.195312 11.894531 -24.195312 C 5.523438 -24.195312 1.695312 -19.554688 1.695312 -11.859375 C 1.695312 -4.167969 5.523438 0.472656 11.894531 0.472656 Z M 6.914062 -11.859375 C 6.914062 -16.570312 8.710938 -19.382812 11.894531 -19.382812 C 15.046875 -19.382812 16.84375 -16.570312 16.84375 -11.859375 C 16.84375 -7.152344 15.046875 -4.335938 11.894531 -4.335938 C 8.710938 -4.335938 6.914062 -7.152344 6.914062 -11.859375 Z M 6.914062 -11.859375 "
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(495.608073, 315.362713)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.472656 0.472656 C 15.792969 0.472656 19.25 -2.507812 19.25 -7.152344 C 19.25 -11.082031 16.671875 -13.929688 12.742188 -14.539062 L 18.265625 -20.0625 L 18.265625 -23.722656 L 2.101562 -23.722656 L 2.101562 -19.078125 L 11.25 -19.078125 L 6.234375 -13.996094 L 6.234375 -10.84375 L 10.402344 -10.84375 C 12.640625 -10.84375 14.097656 -9.554688 14.097656 -7.558594 C 14.097656 -5.558594 12.640625 -4.269531 10.402344 -4.269531 C 8.199219 -4.269531 6.777344 -5.488281 6.675781 -7.421875 L 1.523438 -7.421875 C 1.726562 -2.542969 5.117188 0.472656 10.472656 0.472656 Z M 10.472656 0.472656 "
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(599.313784, 333.019566)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.027344 0.558594 C 21.539062 0.558594 26.054688 -4.914062 26.054688 -13.988281 C 26.054688 -23.058594 21.539062 -28.53125 14.027344 -28.53125 C 6.515625 -28.53125 2 -23.058594 2 -13.988281 C 2 -4.914062 6.515625 0.558594 14.027344 0.558594 Z M 8.152344 -13.988281 C 8.152344 -19.542969 10.269531 -22.859375 14.027344 -22.859375 C 17.742188 -22.859375 19.859375 -19.542969 19.859375 -13.988281 C 19.859375 -8.433594 17.742188 -5.113281 14.027344 -5.113281 C 10.269531 -5.113281 8.152344 -8.433594 8.152344 -13.988281 Z M 8.152344 -13.988281 "
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(627.326901, 333.019566)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.078125 -5.113281 L 15.066406 -5.113281 L 15.066406 0 L 21.300781 0 L 21.300781 -5.113281 L 24.816406 -5.113281 L 24.816406 -10.628906 L 21.300781 -10.628906 L 21.300781 -18.300781 L 16.34375 -18.300781 L 15.386719 -10.511719 L 8.433594 -10.511719 L 17.023438 -27.972656 L 10.109375 -27.972656 L 1.078125 -9.550781 Z M 1.078125 -5.113281 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/Step1.ddfe26ced4595532f75a90500af07682.svg";
export { ForwardRef as ReactComponent };